import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = {
  class: "relative"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  class: "flex items-center justify-between"
};
const _hoisted_7 = {
  class: "list-page-segmented"
};
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_9 = {
  key: 0,
  class: "list-page-table-panel flex min-h-0 flex-1 flex-col p-5"
};
const _hoisted_10 = {
  class: "mb-3 flex items-center justify-between gap-3"
};
const _hoisted_11 = {
  class: "min-w-0 text-sm"
};
const _hoisted_12 = {
  class: "font-semibold text-slate-900"
};
const _hoisted_13 = {
  class: "ml-2 text-xs text-slate-400"
};
const _hoisted_14 = {
  key: 0,
  class: "flex items-center justify-center gap-2 py-10 text-xs text-slate-400"
};
const _hoisted_15 = {
  key: 1,
  class: "empty-state"
};
const _hoisted_16 = {
  key: 2,
  class: "min-h-0 flex-1 space-y-5 overflow-y-auto pr-1"
};
const _hoisted_17 = {
  class: "mb-2 flex items-center gap-2 text-sm font-semibold text-slate-900"
};
const _hoisted_18 = {
  class: "status-badge is-neutral"
};
const _hoisted_19 = {
  class: "space-y-2"
};
const _hoisted_20 = {
  key: 2,
  class: "grid min-h-0 flex-1 grid-cols-1 gap-6 lg:grid-cols-12"
};
const _hoisted_21 = {
  class: "lg:col-span-3"
};
const _hoisted_22 = {
  class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
};
const _hoisted_23 = {
  class: "flex items-center justify-between"
};
const _hoisted_24 = {
  key: 0,
  class: "mt-3 rounded-lg bg-slate-50 p-2"
};
const _hoisted_25 = {
  class: "flex gap-2"
};
const _hoisted_26 = {
  class: "mt-4 space-y-1"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "min-w-0 flex-1"
};
const _hoisted_29 = ["title"];
const _hoisted_30 = {
  class: "mt-0.5 flex items-center gap-1.5 text-[11px] font-normal text-slate-400"
};
const _hoisted_31 = {
  key: 0
};
const _hoisted_32 = {
  key: 1,
  class: "status-badge is-neutral px-1.5 py-0 text-[10px]"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  key: 0,
  class: "empty-state is-compact"
};
const _hoisted_37 = {
  class: "flex min-h-0 flex-col lg:col-span-9"
};
const _hoisted_38 = {
  class: "list-page-table-panel list-page-table-panel--fill flex min-h-0 flex-1 flex-col"
};
const _hoisted_39 = {
  class: "flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 px-5 py-3"
};
const _hoisted_40 = {
  class: "min-w-0"
};
const _hoisted_41 = {
  class: "truncate text-sm font-semibold text-slate-900"
};
const _hoisted_42 = {
  key: 0,
  class: "mt-0.5 truncate text-xs text-slate-400"
};
const _hoisted_43 = {
  class: "flex shrink-0 items-center gap-2"
};
const _hoisted_44 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_45 = {
  key: 1,
  class: "status-badge is-warning"
};
const _hoisted_46 = ["disabled"];
const _hoisted_47 = ["disabled"];
const _hoisted_48 = {
  class: "data-table-shell"
};
const _hoisted_49 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_50 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_51 = {
  key: 1
};
const _hoisted_52 = {
  class: "data-table-td"
};
const _hoisted_53 = {
  class: "flex max-w-[280px] items-center gap-2.5"
};
const _hoisted_54 = ["href", "title"];
const _hoisted_55 = ["title"];
const _hoisted_56 = ["title"];
const _hoisted_57 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_58 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_59 = {
  class: "data-table-td text-center"
};
const _hoisted_60 = {
  class: "data-table-td text-center text-slate-600"
};
const _hoisted_61 = {
  class: "data-table-td"
};
const _hoisted_62 = {
  class: "data-table-cell-ellipsis block max-w-[160px] cursor-default text-red-500"
};
const _hoisted_63 = {
  key: 1,
  class: "text-slate-300"
};
const _hoisted_64 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_65 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_66 = ["onClick"];
const _hoisted_67 = ["onClick"];
const _hoisted_68 = ["title", "aria-label", "onClick"];
const _hoisted_69 = ["disabled", "onClick"];
const _hoisted_70 = ["onClick"];
const _hoisted_71 = ["onClick"];
const _hoisted_72 = {
  key: 0,
  class: "data-table-row"
};
const _hoisted_73 = {
  colspan: "7",
  class: "data-table-td bg-slate-50/60 px-5 py-3"
};
const _hoisted_74 = {
  key: 0,
  class: "flex items-center gap-2 py-2 text-xs text-slate-400"
};
const _hoisted_75 = {
  key: 1,
  class: "py-2 text-xs text-red-500"
};
const _hoisted_76 = {
  key: 2,
  class: "py-2 text-xs text-slate-400"
};
const _hoisted_77 = {
  key: 3,
  class: "space-y-2"
};
const _hoisted_78 = {
  class: "flex flex-wrap items-center gap-2 text-xs"
};
const _hoisted_79 = {
  class: "status-badge is-neutral"
};
const _hoisted_80 = {
  class: "text-slate-400"
};
const _hoisted_81 = ["title"];
const _hoisted_82 = ["checked", "disabled", "onChange"];
const _hoisted_83 = {
  class: "mt-1.5 text-xs leading-relaxed text-slate-600"
};
const _hoisted_84 = ["onClick"];
const _hoisted_85 = {
  key: 1,
  class: "empty-state m-auto"
};
const _hoisted_86 = {
  class: "empty-state-title"
};
const _hoisted_87 = {
  class: "px-6 py-6"
};
const _hoisted_88 = {
  class: "px-6 py-6"
};
const _hoisted_89 = {
  class: "mt-1 text-xs text-slate-400"
};
const _hoisted_90 = {
  class: "px-6 py-6"
};
const _hoisted_91 = {
  class: "mt-1 text-xs text-slate-400"
};
const _hoisted_92 = {
  class: "mt-4 space-y-3"
};
const _hoisted_93 = {
  class: "space-y-1.5"
};
const _hoisted_94 = {
  class: "space-y-1.5"
};
const _hoisted_95 = ["disabled"];
const _hoisted_96 = {
  key: 0,
  class: "py-8 text-center text-sm text-slate-400"
};
const _hoisted_97 = {
  key: 1,
  class: "py-6 text-center text-sm text-red-500"
};
const _hoisted_98 = {
  key: 2,
  class: "space-y-2"
};
const _hoisted_99 = {
  key: 0,
  class: "text-xs text-amber-600"
};
const _hoisted_100 = {
  class: "markdown-body max-h-[60vh] overflow-y-auto text-sm"
};
const _hoisted_101 = {
  class: "relative flex items-center justify-between bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-3"
};
const _hoisted_102 = {
  class: "relative flex min-w-0 items-center gap-3"
};
const _hoisted_103 = {
  class: "truncate text-sm font-medium text-white"
};
const _hoisted_104 = {
  class: "flex-1 overflow-hidden bg-slate-100"
};
const _hoisted_105 = ["src"];
import { computed, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import ListPageShell from '@/components/ListPageShell.vue';
import AppPagination from '@/components/AppPagination.vue';
import AppModal from '@/components/AppModal.vue';
import FileIcon from '@/components/FileIcon.vue';
import SpaceAclPanel from '@/components/chat-input/SpaceAclPanel.vue';
import { createSpace, deleteSpace, deleteSpaceFile, deleteSpaceUrlFile, downloadSpaceFile, getSpaceAcl, getSpaceFileChunks, getSpaceFiles, getSpaceList, importSpaceUrl, renameSpace, retrySpaceFile, retrySpaceUrlImport, searchSpaces, summarizeSpaceFile, toggleSpaceChunk, uploadSpaceFile } from '@/api/aiSpace';
import { renderMarkdown } from '@/utils/markdownLite';
import { uploadFile } from '@/api/file';
import { downloadBlob } from '@/utils/download';
import SpaceHitCard from './components/SpaceHitCard.vue';
import SpaceRecallPanel from './components/SpaceRecallPanel.vue';

// ==================== 常量 ====================
/** PROCESSING 状态轮询间隔（ms），全部 READY/FAILED 后停止 */
const POLL_INTERVAL_MS = 3000;
/** 批量上传并发上限 */
const UPLOAD_CONCURRENCY = 3;

// ==================== 空间列表 ====================

export default {
  __name: 'SpaceManagement',
  setup(__props) {
    const spaces = ref([]);
    const spacesLoading = ref(false);
    const current = ref(null);
    const creating = ref(false);
    const newName = ref('');
    const newDesc = ref('');
    /** spaceId → 文件数（null 表示获取失败，展示 -） */
    const fileCountMap = ref({});
    /** spaceId → 共享范围摘要文案 */
    const aclSummaryMap = ref({});
    function fileCountText(spaceId) {
      const n = fileCountMap.value[spaceId];
      return n == null ? '文件数 -' : `${n} 个文件`;
    }
    function summarizeAcl(list) {
      if (!list.length) return '未共享';
      if (list.some(a => a.subjectType === 'ALL_AUTHENTICATED')) return '全员可见';
      const users = list.filter(a => a.subjectType === 'USER').length;
      const depts = list.filter(a => a.subjectType === 'DEPT').length;
      const parts = [];
      if (users) parts.push(`${users} 名用户`);
      if (depts) parts.push(`${depts} 个部门`);
      return parts.length ? `共享给 ${parts.join('、')}` : `已共享 ${list.length} 项`;
    }
    function normalizeAclResponse(data) {
      return Array.isArray(data) ? data : data && data.records || [];
    }

    /** 单个空间的文件数 + 共享范围摘要（静默降级，不影响列表主流程） */
    async function refreshSpaceSummary(s) {
      if (!s) return;
      try {
        const list = await getSpaceFiles(s.id);
        fileCountMap.value = {
          ...fileCountMap.value,
          [s.id]: Array.isArray(list) ? list.length : 0
        };
      } catch {
        fileCountMap.value = {
          ...fileCountMap.value,
          [s.id]: null
        };
      }
      try {
        const acl = normalizeAclResponse(await getSpaceAcl(s.id));
        aclSummaryMap.value = {
          ...aclSummaryMap.value,
          [s.id]: summarizeAcl(acl)
        };
      } catch {
        aclSummaryMap.value = {
          ...aclSummaryMap.value,
          [s.id]: ''
        };
      }
    }
    async function loadSpaces() {
      spacesLoading.value = true;
      try {
        const list = await getSpaceList();
        spaces.value = Array.isArray(list) ? list : [];
        if (current.value) {
          current.value = spaces.value.find(s => s.id === current.value.id) || null;
        }
        if (!current.value && spaces.value.length) {
          await selectSpace(spaces.value[0]);
        }
        // 摘要异步补齐，不阻塞列表渲染
        spaces.value.forEach(s => {
          refreshSpaceSummary(s);
        });
      } catch (error) {
        ElMessage.error(error && error.message || '加载空间列表失败');
      } finally {
        spacesLoading.value = false;
      }
    }
    async function selectSpace(s) {
      if (current.value && current.value.id === s.id) return;
      stopPolling();
      current.value = s;
      pageInfo.current = 1;
      await loadFiles(true);
    }
    async function handleCreate() {
      if (!newName.value.trim()) {
        ElMessage.warning('请输入空间名');
        return;
      }
      try {
        const created = await createSpace({
          name: newName.value.trim(),
          description: newDesc.value.trim()
        });
        creating.value = false;
        newName.value = '';
        newDesc.value = '';
        const list = await getSpaceList();
        spaces.value = Array.isArray(list) ? list : [];
        const target = spaces.value.find(s => s.id === created.id) || created;
        current.value = null;
        await selectSpace(target);
        refreshSpaceSummary(target);
        ElMessage.success('空间创建成功');
      } catch (error) {
        ElMessage.error(error && error.message || '创建空间失败');
      }
    }

    // ==================== 重命名 ====================
    const showRenameModal = ref(false);
    const renameTarget = ref(null);
    const renameValue = ref('');
    function openRenameModal(s) {
      renameTarget.value = s;
      renameValue.value = s.name;
      showRenameModal.value = true;
    }
    async function submitRename() {
      if (!renameValue.value.trim()) {
        ElMessage.warning('请输入新名称');
        return;
      }
      try {
        await renameSpace(renameTarget.value.id, {
          name: renameValue.value.trim(),
          description: renameTarget.value.description
        });
        showRenameModal.value = false;
        const list = await getSpaceList();
        spaces.value = Array.isArray(list) ? list : [];
        if (current.value && current.value.id === renameTarget.value.id) {
          current.value = spaces.value.find(s => s.id === current.value.id) || current.value;
        }
        ElMessage.success('重命名成功');
      } catch (error) {
        ElMessage.error(error && error.message || '重命名失败');
      }
    }

    // ==================== 共享管理 ====================
    const showShareModal = ref(false);
    const shareTarget = ref(null);
    function openShareModal(s) {
      shareTarget.value = s;
      showShareModal.value = true;
    }

    // ==================== 删除空间 ====================
    async function handleDeleteSpace(s) {
      const count = current.value && current.value.id === s.id ? files.value.length : fileCountMap.value[s.id] ?? 0;
      try {
        await ElMessageBox.confirm(`确认删除空间「${s.name}」？空间内 ${count} 个文件的知识向量将一并删除，不可恢复。`, '删除空间', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      try {
        await deleteSpace(s.id);
        ElMessage.success('空间已删除');
        if (current.value && current.value.id === s.id) {
          stopPolling();
          current.value = null;
          files.value = [];
        }
        await loadSpaces();
      } catch (error) {
        ElMessage.error(error && error.message || '删除空间失败');
      }
    }

    // ==================== 文件列表与轮询 ====================
    const files = ref([]);
    const filesLoading = ref(false);
    let pollTimer = null;
    const hasProcessing = computed(() => files.value.some(f => f.processStatus === 'PROCESSING'));
    async function loadFiles(withLoading = false) {
      if (!current.value) return;
      const spaceId = current.value.id;
      if (withLoading) filesLoading.value = true;
      try {
        const list = await getSpaceFiles(spaceId);
        // 轮询/切换竞态防护：仅当仍停留在同一空间时落数据
        if (!current.value || current.value.id !== spaceId) return;
        files.value = Array.isArray(list) ? list : [];
        fileCountMap.value = {
          ...fileCountMap.value,
          [spaceId]: files.value.length
        };
        syncPolling();
      } catch (error) {
        if (withLoading) ElMessage.error(error && error.message || '加载文件列表失败');
      } finally {
        if (withLoading) filesLoading.value = false;
      }
    }

    /** 存在 PROCESSING 行时启动 3s 轮询，全部 READY/FAILED 后停止 */
    function syncPolling() {
      if (hasProcessing.value && !pollTimer) {
        pollTimer = setInterval(() => {
          loadFiles(false);
        }, POLL_INTERVAL_MS);
      } else if (!hasProcessing.value && pollTimer) {
        stopPolling();
      }
    }
    function stopPolling() {
      if (pollTimer) {
        clearInterval(pollTimer);
        pollTimer = null;
      }
    }

    // ==================== 批量上传（两段式，并发上限 3） ====================
    const uploadingCount = ref(0);
    async function handleUpload(e) {
      const picked = Array.from(e.target.files || []);
      e.target.value = '';
      if (!picked.length || !current.value) return;
      const spaceId = current.value.id;
      uploadingCount.value += picked.length;
      const queue = [...picked];
      let okCount = 0;
      const worker = async () => {
        while (queue.length) {
          const file = queue.shift();
          try {
            // 两段式：/file/upload 拿 fileKey → POST /ai/spaces/{id}/files 登记触发 RAG
            const uploaded = await uploadFile(file, 'space', 'public');
            await uploadSpaceFile(spaceId, {
              fileName: file.name,
              fileKey: uploaded.fileName,
              fileSize: file.size,
              fileType: file.name.split('.').pop() || '',
              uploaderName: ''
            });
            okCount += 1;
          } catch (err) {
            // 单个失败不中断其余文件
            ElMessage.error(`「${file.name}」上传失败：${err && err.message || '未知错误'}`);
          } finally {
            uploadingCount.value -= 1;
            loadFiles(false);
          }
        }
      };
      await Promise.all(Array.from({
        length: Math.min(UPLOAD_CONCURRENCY, picked.length)
      }, () => worker()));
      if (okCount) ElMessage.success(`已上传 ${okCount} 个文件，RAG 处理中`);
      refreshSpaceSummary(current.value);
    }

    // ==================== 文件操作 ====================
    const STATUS_TEXT = {
      PROCESSING: '处理中',
      READY: '已就绪',
      FAILED: '失败'
    };
    function statusText(s) {
      return STATUS_TEXT[s] || s || '-';
    }
    function statusClass(s) {
      if (s === 'READY') return 'status-badge is-success';
      if (s === 'FAILED') return 'status-badge is-danger';
      if (s === 'PROCESSING') return 'status-badge is-warning';
      return 'status-badge is-neutral';
    }
    const formatFileSize = bytes => {
      if (!bytes) return '-';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };

    /** FAILED 行手动重推（文件行按 attachmentId；URL 行按 file_id 重推 url_import）：成功后回到 PROCESSING 并启动轮询 */
    async function handleRetryFile(f) {
      try {
        if (f.sourceType === 'URL') {
          await retrySpaceUrlImport(current.value.id, f.id);
        } else {
          await retrySpaceFile(current.value.id, f.attachmentId);
        }
        const row = files.value.find(item => item.id === f.id);
        if (row) {
          row.processStatus = 'PROCESSING';
          row.error = null;
          row.chunkCount = null;
        }
        syncPolling();
        ElMessage.success('已重新提交处理');
      } catch (error) {
        ElMessage.error(error && error.message || '重试失败');
      }
    }
    async function handleDeleteFile(f) {
      const isUrl = f.sourceType === 'URL';
      try {
        await ElMessageBox.confirm(`确认删除${isUrl ? '网页' : '文件'}「${f.fileName}」？其知识向量将一并删除，不可恢复。`, isUrl ? '删除网页' : '删除文件', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      try {
        if (isUrl) {
          await deleteSpaceUrlFile(current.value.id, f.id);
        } else {
          await deleteSpaceFile(current.value.id, f.attachmentId);
        }
        ElMessage.success(isUrl ? '网页已删除' : '文件已删除');
        await loadFiles(false);
        refreshSpaceSummary(current.value);
      } catch (error) {
        ElMessage.error(error && error.message || '删除失败');
      }
    }

    // ==================== URL 网页导入（契约 v1.3 §6.1） ====================
    const showUrlImportModal = ref(false);
    const urlImporting = ref(false);
    const urlImportForm = reactive({
      url: '',
      title: ''
    });
    function openUrlImportModal() {
      urlImportForm.url = '';
      urlImportForm.title = '';
      showUrlImportModal.value = true;
    }
    async function submitUrlImport() {
      const url = urlImportForm.url.trim();
      // 前端预校验：仅 http/https（CRM/agent 侧另有 SSRF 防护，双保险）
      if (!/^https?:\/\/\S+$/i.test(url)) {
        ElMessage.warning('请输入合法的 http/https 链接');
        return;
      }
      urlImporting.value = true;
      try {
        await importSpaceUrl(current.value.id, {
          url,
          title: urlImportForm.title.trim() || undefined
        });
        showUrlImportModal.value = false;
        ElMessage.success('已提交导入，处理中');
        await loadFiles(false);
        refreshSpaceSummary(current.value);
      } catch (error) {
        // 同空间同 URL 重复导入由 CRM 拒绝，业务 message 在此展示（拦截器对业务码不弹）
        ElMessage.error(error && error.message || '导入失败');
      } finally {
        urlImporting.value = false;
      }
    }

    // ==================== 分段可视化管理（契约 v1.3 §13） ====================
    const chunkExpanded = reactive({}); // 行 id → 分段区是否展开
    const chunkStates = reactive({}); // 行 id → {loading, chunks, error}
    const chunkTextExpanded = reactive({}); // doc_id → 分段全文是否展开
    const chunkToggling = reactive({}); // doc_id → 启停请求在途

    /** 仅 MANAGE（当前 DTO 语义 = owner）可切换启停；VIEW 只读展示 */
    const canManageChunks = computed(() => current.value?.permissionLevel === 'MANAGE');
    function chunkStateOf(rowId) {
      return chunkStates[rowId] || {
        loading: false,
        chunks: [],
        error: ''
      };
    }
    async function toggleChunksExpand(f) {
      if (chunkExpanded[f.id]) {
        chunkExpanded[f.id] = false;
        return;
      }
      chunkExpanded[f.id] = true;
      loadChunks(f);
    }
    async function loadChunks(f) {
      chunkStates[f.id] = {
        loading: true,
        chunks: [],
        error: ''
      };
      try {
        // 文件行传 attachmentId；URL 行传 urlFileId（= ai_space_file.id，其 attachmentId 为 null）
        const params = f.sourceType === 'URL' ? {
          urlFileId: f.id
        } : {
          attachmentId: f.attachmentId
        };
        const data = await getSpaceFileChunks(current.value.id, params);
        const chunks = data && data.chunks || (Array.isArray(data) ? data : []);
        chunkStates[f.id] = {
          loading: false,
          chunks,
          error: ''
        };
      } catch (error) {
        chunkStates[f.id] = {
          loading: false,
          chunks: [],
          error: error && error.message || '加载分段失败'
        };
      }
    }

    /** 启停切换：成功行内即时更新 enabled；失败回拨原生 checkbox，禁用分段由 agent 侧从检索/问答排除 */
    async function handleToggleChunk(c, event) {
      const enabled = Boolean(event && event.target && event.target.checked);
      chunkToggling[c.doc_id] = true;
      try {
        await toggleSpaceChunk(current.value.id, {
          docId: c.doc_id,
          enabled
        });
        c.enabled = enabled;
        ElMessage.success(enabled ? '分段已启用' : '分段已禁用（检索/问答不再命中）');
      } catch (error) {
        if (event && event.target) event.target.checked = !enabled;
        ElMessage.error(error && error.message || '切换失败');
      } finally {
        chunkToggling[c.doc_id] = false;
      }
    }

    // 下载/预览走空间附件端点（契约 v1.2 §12：VIEW 校验 + IDOR 防护，替代 kb policy 借用）
    async function handleDownload(f) {
      try {
        const blob = await downloadSpaceFile(current.value.id, f.attachmentId);
        downloadBlob(blob, f.fileName);
      } catch (error) {
        ElMessage.error(error && error.message || '下载失败');
      }
    }
    const showPreviewModal = ref(false);
    const previewUrl = ref('');
    const previewFileName = ref('');
    async function handlePreview(f) {
      await previewSpaceFile(current.value.id, f.attachmentId, f.fileName);
    }

    /** 搜索/召回命中卡片预览：按命中的 space_id + attachment_id 定位附件 */
    function handlePreviewHit(hit) {
      previewSpaceFile(hit.space_id, hit.attachment_id, hit.filename || '');
    }

    /** PDF blob 预览（沿用 W5 模式）；非 PDF 提示下载 */
    async function previewSpaceFile(spaceId, attachmentId, fileName) {
      const ext = (String(fileName).split('.').pop() || '').toLowerCase();
      if (ext !== 'pdf') {
        ElMessage.warning('仅支持 PDF 文件预览，其他格式请下载后查看');
        return;
      }
      try {
        const response = await downloadSpaceFile(spaceId, attachmentId);
        if (previewUrl.value) {
          window.URL.revokeObjectURL(previewUrl.value);
        }
        const blob = new Blob([response], {
          type: 'application/pdf'
        });
        previewUrl.value = window.URL.createObjectURL(blob);
        previewFileName.value = fileName;
        showPreviewModal.value = true;
      } catch (error) {
        ElMessage.error(error && error.message || '预览加载失败');
      }
    }

    // ==================== 视图切换与全局搜索 ====================
    const activeTab = ref('files');
    function switchTab(tab) {
      activeTab.value = tab;
      globalSearchActive.value = false;
    }
    const globalQuery = ref('');
    const globalUploader = ref(''); // filters.uploader（等值，可空）
    const globalFilenameLike = ref(''); // filters.filename_like（子串，大小写不敏感，可空）
    const globalUploadedAfter = ref(''); // filters.uploaded_after（yyyy-MM-dd，可空；仅新入库文件有 pushed_at）
    const globalUploadedBefore = ref(''); // filters.uploaded_before（闭区间含当天，agent 侧补 T23:59:59）
    const globalSearching = ref(false);
    const globalSearchActive = ref(false);
    const globalHits = ref([]);
    const globalMode = ref('');
    const lastGlobalQuery = ref('');

    /** 组装 §9 filters：空值不传；全空返回 null（payload 不带 filters 字段） */
    function buildFilters(uploader, filenameLike, after, before) {
      const filters = {};
      const u = (uploader || '').trim();
      const fl = (filenameLike || '').trim();
      const af = (after || '').trim();
      const bf = (before || '').trim();
      if (u) filters.uploader = u;
      if (fl) filters.filename_like = fl;
      // 契约 v1.4 §9：时间过滤（yyyy-MM-dd；仅新入库文件有 pushed_at，存量文件不参与命中）
      if (af) filters.uploaded_after = af;
      if (bf) filters.uploaded_before = bf;
      return Object.keys(filters).length ? filters : null;
    }

    /** 命中按 space_name 分组（保持后端降序得分的组内顺序） */
    const globalGroups = computed(() => {
      const map = new Map();
      for (const h of globalHits.value) {
        const key = h.space_name || `空间 ${h.space_id}`;
        if (!map.has(key)) map.set(key, []);
        map.get(key).push(h);
      }
      return [...map.entries()].map(([spaceName, hits]) => ({
        spaceName,
        hits
      }));
    });

    /** 全局搜索：spaceIds 空 = 当前用户全部可见空间（CRM 代理注入白名单 + VIEW 校验） */
    async function handleGlobalSearch() {
      const q = globalQuery.value.trim();
      if (!q) {
        ElMessage.warning('请输入搜索关键词');
        return;
      }
      lastGlobalQuery.value = q;
      globalSearchActive.value = true;
      globalSearching.value = true;
      try {
        const payload = {
          spaceIds: [],
          query: q,
          topK: 20
        };
        const filters = buildFilters(globalUploader.value, globalFilenameLike.value, globalUploadedAfter.value, globalUploadedBefore.value);
        if (filters) payload.filters = filters;
        const data = await searchSpaces(payload);
        globalHits.value = data && data.hits || [];
        globalMode.value = data && data.mode || '';
      } catch (error) {
        globalHits.value = [];
        globalMode.value = '';
        ElMessage.error(error && error.message || '搜索失败');
      } finally {
        globalSearching.value = false;
      }
    }
    function clearGlobalSearch() {
      globalSearchActive.value = false;
      globalHits.value = [];
      globalMode.value = '';
    }
    function closePreviewModal() {
      showPreviewModal.value = false;
      if (previewUrl.value) {
        window.URL.revokeObjectURL(previewUrl.value);
        previewUrl.value = '';
      }
      previewFileName.value = '';
    }

    // ==================== AI 摘要（契约 v1.4 §14） ====================
    const showSummaryModal = ref(false);
    const summaryLoading = ref(false);
    const summaryLoadingId = ref(null);
    const summaryError = ref('');
    const summaryFileName = ref('');
    const summaryHtml = ref('');
    const summaryTruncated = ref(false);
    const summaryWarnings = ref([]);

    /** READY 行（FILE/URL 均可）生成结构化摘要；LLM 10-30s，弹窗内 loading，防重复点击 */
    async function handleSummarize(f) {
      summaryFileName.value = f.fileName;
      summaryError.value = '';
      summaryHtml.value = '';
      summaryTruncated.value = false;
      summaryWarnings.value = [];
      showSummaryModal.value = true;
      summaryLoading.value = true;
      summaryLoadingId.value = f.id;
      try {
        const params = f.sourceType === 'URL' ? {
          urlFileId: f.id
        } : {
          attachmentId: f.attachmentId
        };
        const data = await summarizeSpaceFile(current.value.id, params);
        summaryHtml.value = renderMarkdown(data && data.summary || '');
        summaryTruncated.value = Boolean(data && data.truncated);
        summaryWarnings.value = data && data.warnings || [];
      } catch (error) {
        summaryError.value = error && error.message || '摘要生成失败';
      } finally {
        summaryLoading.value = false;
        summaryLoadingId.value = null;
      }
    }

    // ==================== 分页（前端切片） ====================
    const pageSize = ref(20);
    const pageInfo = reactive({
      current: 1
    });
    const pagedFiles = computed(() => {
      const start = (pageInfo.current - 1) * pageSize.value;
      return files.value.slice(start, start + pageSize.value);
    });

    // 文件删除/轮询导致总数变化时，收敛页码避免停留在空页
    watch(() => files.value.length, () => {
      const maxPage = Math.max(1, Math.ceil(files.value.length / pageSize.value));
      if (pageInfo.current > maxPage) pageInfo.current = maxPage;
    });
    function handlePageChange(page) {
      pageInfo.current = page;
    }
    function handlePageSizeChange(size) {
      pageSize.value = size;
      pageInfo.current = 1;
    }

    // ==================== 生命周期 ====================
    onMounted(loadSpaces);
    onUnmounted(() => {
      stopPolling();
      if (previewUrl.value) {
        window.URL.revokeObjectURL(previewUrl.value);
        previewUrl.value = '';
      }
    });
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[25] || (_cache[25] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "知识空间"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理个人与共享的知识空间，上传文件自动切块向量化，供申报助手检索引用。")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => globalQuery.value = $event),
          type: "text",
          class: "form-search-input form-control-sm w-72",
          placeholder: "全局搜索：跨可见空间搜知识分段",
          onKeyup: _withKeys(handleGlobalSearch, ["enter"])
        }, null, 544), [[_vModelText, globalQuery.value]]), _cache[24] || (_cache[24] = _createElementVNode("svg", {
          class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        })], -1))]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => globalUploader.value = $event),
          class: "form-input form-control-sm w-24",
          placeholder: "上传者",
          title: "过滤：上传者（等值匹配）"
        }, null, 512), [[_vModelText, globalUploader.value]]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => globalFilenameLike.value = $event),
          class: "form-input form-control-sm w-28",
          placeholder: "文件名包含",
          title: "过滤：文件名子串（大小写不敏感）"
        }, null, 512), [[_vModelText, globalFilenameLike.value]]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => globalUploadedAfter.value = $event),
          type: "date",
          class: "form-input form-control-sm w-36",
          title: "过滤：上传时间 ≥（契约 v1.4，仅对新入库文件生效）"
        }, null, 512), [[_vModelText, globalUploadedAfter.value]]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => globalUploadedBefore.value = $event),
          type: "date",
          class: "form-input form-control-sm w-36",
          title: "过滤：上传时间 ≤（契约 v1.4，仅对新入库文件生效）"
        }, null, 512), [[_vModelText, globalUploadedBefore.value]]), _createElementVNode("button", {
          class: "btn-primary form-control-sm",
          disabled: globalSearching.value,
          onClick: handleGlobalSearch
        }, _toDisplayString(globalSearching.value ? '搜索中…' : '搜索'), 9, _hoisted_5)])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
          class: _normalizeClass(["list-page-segmented-item", {
            'is-active': activeTab.value === 'files'
          }]),
          onClick: _cache[5] || (_cache[5] = $event => switchTab('files'))
        }, "📂 文件管理", 2), _createElementVNode("button", {
          class: _normalizeClass(["list-page-segmented-item", {
            'is-active': activeTab.value === 'recall'
          }]),
          onClick: _cache[6] || (_cache[6] = $event => switchTab('recall'))
        }, "🎯 召回测试", 2)]), globalSearchActive.value ? (_openBlock(), _createElementBlock("span", _hoisted_8, "正在展示全局搜索结果")) : _createCommentVNode("", true)]), globalSearchActive.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, "「" + _toDisplayString(lastGlobalQuery.value) + "」", 1), _createElementVNode("span", _hoisted_13, [_createTextVNode(" 共 " + _toDisplayString(globalHits.value.length) + " 条命中", 1), globalMode.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(" · 模式 " + _toDisplayString(globalMode.value), 1)], 64)) : _createCommentVNode("", true)])]), _createElementVNode("button", {
          class: "btn-secondary form-control-sm shrink-0",
          onClick: clearGlobalSearch
        }, "清除并返回")]), globalSearching.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[26] || (_cache[26] = [_createElementVNode("span", {
          class: "app-spinner is-sm"
        }, null, -1), _createTextVNode(" 搜索中… ", -1)]))])) : !globalGroups.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[27] || (_cache[27] = [_createElementVNode("div", {
          class: "empty-state-icon"
        }, "🔍", -1), _createElementVNode("p", {
          class: "empty-state-title"
        }, "未找到相关知识分段", -1), _createElementVNode("p", {
          class: "empty-state-desc"
        }, "换个关键词试试，或确认空间内已有 READY 状态的文件", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(globalGroups.value, g => {
          return _openBlock(), _createElementBlock("section", {
            key: g.spaceName
          }, [_createElementVNode("h3", _hoisted_17, [_createTextVNode(" 📚 " + _toDisplayString(g.spaceName) + " ", 1), _createElementVNode("span", _hoisted_18, _toDisplayString(g.hits.length) + " 条命中", 1)]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.hits, (h, i) => {
            return _openBlock(), _createBlock(SpaceHitCard, {
              key: h.doc_id || i,
              hit: h,
              query: lastGlobalQuery.value,
              index: i,
              onPreview: handlePreviewHit
            }, null, 8, ["hit", "query", "index"]);
          }), 128))])]);
        }), 128))]))])) : activeTab.value === 'recall' ? (_openBlock(), _createBlock(SpaceRecallPanel, {
          key: 1,
          class: "min-h-0 flex-1 overflow-y-auto",
          spaces: spaces.value,
          onPreview: handlePreviewHit
        }, null, 8, ["spaces"])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[28] || (_cache[28] = _createElementVNode("h2", {
          class: "text-base font-semibold text-slate-900"
        }, "我的空间", -1)), _createElementVNode("button", {
          class: "rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50",
          onClick: _cache[7] || (_cache[7] = $event => creating.value = !creating.value)
        }, "新建空间")]), _cache[35] || (_cache[35] = _createElementVNode("p", {
          class: "mt-2 text-xs text-slate-500"
        }, "空间用于挂载申报助手的知识资料，可共享给指定用户或部门。", -1)), creating.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => newName.value = $event),
          class: "form-input form-control-sm mb-1 w-full",
          placeholder: "空间名（如：物料分析）"
        }, null, 512), [[_vModelText, newName.value]]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => newDesc.value = $event),
          class: "form-input form-control-sm mb-2 w-full",
          placeholder: "描述（可选）"
        }, null, 512), [[_vModelText, newDesc.value]]), _createElementVNode("div", _hoisted_25, [_createElementVNode("button", {
          class: "btn-primary form-control-sm flex-1",
          onClick: handleCreate
        }, "创建"), _createElementVNode("button", {
          class: "btn-secondary form-control-sm flex-1",
          onClick: _cache[10] || (_cache[10] = $event => creating.value = false)
        }, "取消")])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, [spacesLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(4, n => {
          return _createElementVNode("div", {
            key: n,
            class: "animate-pulse rounded-lg bg-slate-50 px-3 py-3"
          }, [...(_cache[29] || (_cache[29] = [_createElementVNode("div", {
            class: "h-3.5 w-24 rounded bg-slate-200"
          }, null, -1)]))]);
        }), 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spaces.value, s => {
          return _openBlock(), _createElementBlock("div", {
            key: s.id,
            class: _normalizeClass(["group flex cursor-pointer items-center gap-2 rounded-lg px-3 py-2 text-sm transition", current.value && current.value.id === s.id ? 'bg-primary-50 font-medium text-primary-700' : 'text-slate-600 hover:bg-slate-50']),
            onClick: $event => selectSpace(s)
          }, [_cache[33] || (_cache[33] = _createElementVNode("span", {
            class: "shrink-0 text-base leading-none"
          }, "📚", -1)), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
            class: "truncate",
            title: s.name
          }, _toDisplayString(s.name), 9, _hoisted_29), _createElementVNode("div", _hoisted_30, [_createElementVNode("span", null, _toDisplayString(fileCountText(s.id)), 1), aclSummaryMap.value[s.id] ? (_openBlock(), _createElementBlock("span", _hoisted_31, "· " + _toDisplayString(aclSummaryMap.value[s.id]), 1)) : _createCommentVNode("", true), s.permissionLevel === 'VIEW' ? (_openBlock(), _createElementBlock("span", _hoisted_32, "共享给我")) : _createCommentVNode("", true)])]), _createElementVNode("div", {
            class: "flex shrink-0 items-center gap-0.5 opacity-0 transition-opacity group-hover:opacity-100",
            onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
          }, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "重命名",
            "aria-label": "重命名",
            onClick: $event => openRenameModal(s)
          }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_33), _createElementVNode("button", {
            class: "table-action-button is-teal",
            title: "共享",
            "aria-label": "共享",
            onClick: $event => openShareModal(s)
          }, [...(_cache[31] || (_cache[31] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
          })], -1)]))], 8, _hoisted_34), _createElementVNode("button", {
            class: "table-action-button is-danger",
            title: "删除空间",
            "aria-label": "删除空间",
            onClick: $event => handleDeleteSpace(s)
          }, [...(_cache[32] || (_cache[32] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_35)])], 10, _hoisted_27);
        }), 128)), !spacesLoading.value && !spaces.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[34] || (_cache[34] = [_createElementVNode("div", {
          class: "empty-state-icon"
        }, "📚", -1), _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无知识空间", -1), _createElementVNode("p", {
          class: "empty-state-desc"
        }, "点击\"新建空间\"创建第一个知识空间", -1)]))])) : _createCommentVNode("", true)], 64))])])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [current.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("h2", _hoisted_41, _toDisplayString(current.value.name), 1), current.value.description ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(current.value.description), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_43, [uploadingCount.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_44, "正在上传 " + _toDisplayString(uploadingCount.value) + " 个文件…", 1)) : _createCommentVNode("", true), hasProcessing.value ? (_openBlock(), _createElementBlock("span", _hoisted_45, "处理中，自动刷新")) : _createCommentVNode("", true), _createElementVNode("label", {
          class: _normalizeClass(["btn-primary form-control-sm cursor-pointer", uploadingCount.value > 0 ? 'pointer-events-none opacity-50' : ''])
        }, [_cache[36] || (_cache[36] = _createTextVNode(" 上传文件 ", -1)), _createElementVNode("input", {
          type: "file",
          multiple: "",
          class: "hidden",
          accept: ".pdf,.docx,.txt,.xlsx,.pptx,.jpg,.jpeg,.png,.bmp,.webp",
          disabled: uploadingCount.value > 0,
          onChange: handleUpload
        }, null, 40, _hoisted_46)], 2), _createElementVNode("button", {
          class: "btn-outline-primary form-control-sm",
          title: "抓取网页正文入库（仅 http/https）",
          onClick: openUrlImportModal
        }, "导入网页"), _createElementVNode("button", {
          class: "btn-secondary form-control-sm",
          disabled: filesLoading.value,
          onClick: _cache[12] || (_cache[12] = $event => loadFiles(true))
        }, "刷新", 8, _hoisted_47)])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("table", _hoisted_50, [_cache[48] || (_cache[48] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "文件名"), _createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "大小"), _createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "上传者"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "状态"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "分段数"), _createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "失败原因"), _createElementVNode("th", {
          class: "px-5 py-3 text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [filesLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "data-table-row"
          }, [...(_cache[37] || (_cache[37] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-48"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-14"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-16"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-5 w-14 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-8"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-20"
          })], -1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "mx-auto flex justify-center gap-2"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          })])], -1)]))]);
        }), 64)) : !files.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [...(_cache[38] || (_cache[38] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, " 暂无文件，点击右上角\"上传文件\"。支持 pdf/docx/txt/xlsx/pptx/jpg/png，单文件 ≤20MB；.doc/.xls 旧格式请先转换（图片经 OCR 识别入库） ", -1)]))])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagedFiles.value, f => {
          return _openBlock(), _createElementBlock("tr", {
            key: f.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_52, [_createElementVNode("div", _hoisted_53, [f.sourceType === 'URL' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_cache[39] || (_cache[39] = _createElementVNode("span", {
            class: "flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-cyan-50 text-cyan-600",
            title: "网页导入"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
          })])], -1)), f.url ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: f.url,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "data-table-cell-title truncate text-primary-600 hover:underline",
            title: f.url
          }, _toDisplayString(f.fileName), 9, _hoisted_54)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "data-table-cell-title truncate cursor-default",
            title: f.fileName
          }, _toDisplayString(f.fileName), 9, _hoisted_55))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(FileIcon, {
            filename: f.fileName,
            class: "h-7 w-7 shrink-0"
          }, null, 8, ["filename"]), _createElementVNode("div", {
            class: "data-table-cell-title truncate cursor-default",
            title: f.fileName
          }, _toDisplayString(f.fileName), 9, _hoisted_56)], 64))])]), _createElementVNode("td", _hoisted_57, _toDisplayString(formatFileSize(f.fileSize)), 1), _createElementVNode("td", _hoisted_58, _toDisplayString(f.uploaderName || '-'), 1), _createElementVNode("td", _hoisted_59, [_createElementVNode("span", {
            class: _normalizeClass(statusClass(f.processStatus))
          }, _toDisplayString(statusText(f.processStatus)), 3)]), _createElementVNode("td", _hoisted_60, _toDisplayString(f.processStatus === 'READY' ? f.chunkCount ?? '-' : '-'), 1), _createElementVNode("td", _hoisted_61, [f.processStatus === 'FAILED' ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            content: f.error || '处理失败',
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_62, _toDisplayString(f.error || '处理失败'), 1)]),
            _: 2
          }, 1032, ["content"])) : (_openBlock(), _createElementBlock("span", _hoisted_63, "-"))]), _createElementVNode("td", _hoisted_64, [_createElementVNode("div", _hoisted_65, [f.sourceType !== 'URL' ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-primary",
            title: "预览",
            "aria-label": "预览",
            onClick: $event => handlePreview(f)
          }, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_66)) : _createCommentVNode("", true), f.sourceType !== 'URL' ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-indigo",
            title: "下载",
            "aria-label": "下载",
            onClick: $event => handleDownload(f)
          }, [...(_cache[41] || (_cache[41] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
          })], -1)]))], 8, _hoisted_67)) : _createCommentVNode("", true), f.processStatus === 'READY' ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "table-action-button is-neutral",
            title: chunkExpanded[f.id] ? '收起分段' : '分段管理',
            "aria-label": chunkExpanded[f.id] ? '收起分段' : '分段管理',
            onClick: $event => toggleChunksExpand(f)
          }, [...(_cache[42] || (_cache[42] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6h16M4 10h16M4 14h10M4 18h7"
          })], -1)]))], 8, _hoisted_68)) : _createCommentVNode("", true), f.processStatus === 'READY' ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: "table-action-button is-neutral",
            disabled: summaryLoadingId.value === f.id,
            title: "AI 摘要",
            "aria-label": "AI 摘要",
            onClick: $event => handleSummarize(f)
          }, [...(_cache[43] || (_cache[43] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
          })], -1)]))], 8, _hoisted_69)) : _createCommentVNode("", true), f.processStatus === 'FAILED' ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            class: "table-action-button is-warning",
            title: "重试",
            "aria-label": "重试",
            onClick: $event => handleRetryFile(f)
          }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          })], -1)]))], 8, _hoisted_70)) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => handleDeleteFile(f)
          }, [...(_cache[45] || (_cache[45] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_71)])])]);
        }), 128)), chunkExpanded[_ctx.f.id] ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [_createElementVNode("td", _hoisted_73, [chunkStateOf(_ctx.f.id).loading ? (_openBlock(), _createElementBlock("div", _hoisted_74, [...(_cache[46] || (_cache[46] = [_createElementVNode("span", {
          class: "app-spinner is-sm"
        }, null, -1), _createTextVNode(" 加载分段中… ", -1)]))])) : chunkStateOf(_ctx.f.id).error ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(chunkStateOf(_ctx.f.id).error), 1)) : !chunkStateOf(_ctx.f.id).chunks.length ? (_openBlock(), _createElementBlock("div", _hoisted_76, "暂无分段")) : (_openBlock(), _createElementBlock("div", _hoisted_77, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunkStateOf(_ctx.f.id).chunks, c => {
          return _openBlock(), _createElementBlock("div", {
            key: c.doc_id,
            class: "rounded-lg border border-slate-200 bg-white p-2.5"
          }, [_createElementVNode("div", _hoisted_78, [_createElementVNode("span", _hoisted_79, "chunk#" + _toDisplayString(c.chunk_no), 1), _createElementVNode("span", _hoisted_80, "char " + _toDisplayString(c.char_start ?? '-') + "–" + _toDisplayString(c.char_end ?? '-'), 1), _createElementVNode("span", {
            class: _normalizeClass(c.enabled !== false ? 'status-badge is-success' : 'status-badge is-danger')
          }, _toDisplayString(c.enabled !== false ? '已启用' : '已禁用'), 3), _createElementVNode("label", {
            class: "form-switch ml-auto",
            title: canManageChunks.value ? c.enabled !== false ? '点击禁用（检索/问答不再命中）' : '点击启用' : '仅空间管理者可切换'
          }, [_createElementVNode("input", {
            type: "checkbox",
            class: "form-switch-input",
            checked: c.enabled !== false,
            disabled: !canManageChunks.value || chunkToggling[c.doc_id],
            onChange: $event => handleToggleChunk(c, $event)
          }, null, 40, _hoisted_82), _cache[47] || (_cache[47] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1))], 8, _hoisted_81)]), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", {
            class: _normalizeClass(chunkTextExpanded[c.doc_id] ? 'whitespace-pre-wrap break-words' : 'line-clamp-3')
          }, _toDisplayString(c.text), 3), (c.text || '').length > 120 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "mt-1 text-xs text-primary-600 hover:underline",
            onClick: $event => chunkTextExpanded[c.doc_id] = !chunkTextExpanded[c.doc_id]
          }, _toDisplayString(chunkTextExpanded[c.doc_id] ? '收起' : '展开全文'), 9, _hoisted_84)) : _createCommentVNode("", true)])]);
        }), 128))]))])])) : _createCommentVNode("", true)], 64))])])])]), files.value.length > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          current: pageInfo.current,
          total: files.value.length,
          size: pageSize.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current", "total", "size"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_85, [_cache[49] || (_cache[49] = _createElementVNode("div", {
          class: "empty-state-icon"
        }, "📂", -1)), _createElementVNode("p", _hoisted_86, _toDisplayString(spaces.value.length ? '选择左侧空间查看文件' : '请先创建知识空间'), 1), _cache[50] || (_cache[50] = _createElementVNode("p", {
          class: "empty-state-desc"
        }, "空间内文件将自动切块向量化，供申报助手检索引用", -1))]))])])])), _createVNode(AppModal, {
          visible: showRenameModal.value,
          size: "sm",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[15] || (_cache[15] = $event => showRenameModal.value = false)
        }, {
          footer: _withCtx(() => [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[14] || (_cache[14] = $event => showRenameModal.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            onClick: submitRename
          }, "保存")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_87, [_cache[51] || (_cache[51] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "重命名空间", -1)), _cache[52] || (_cache[52] = _createElementVNode("p", {
            class: "mt-1 text-xs text-slate-400"
          }, "改名后检索命中的空间名将同步更新", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => renameValue.value = $event),
            class: "form-input mt-4 w-full",
            placeholder: "请输入新名称",
            onKeyup: _withKeys(submitRename, ["enter"])
          }, null, 544), [[_vModelText, renameValue.value]])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showShareModal.value,
          size: "lg",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[18] || (_cache[18] = $event => showShareModal.value = false)
        }, {
          footer: _withCtx(() => [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[17] || (_cache[17] = $event => showShareModal.value = false)
          }, "关闭")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_88, [_cache[53] || (_cache[53] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "共享管理", -1)), _createElementVNode("p", _hoisted_89, "空间「" + _toDisplayString(shareTarget.value?.name) + "」的授权范围", 1), shareTarget.value ? (_openBlock(), _createBlock(SpaceAclPanel, {
            key: 0,
            "space-id": shareTarget.value.id,
            editable: shareTarget.value.permissionLevel === 'MANAGE',
            class: "mt-4",
            onChanged: _cache[16] || (_cache[16] = $event => refreshSpaceSummary(shareTarget.value))
          }, null, 8, ["space-id", "editable"])) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showUrlImportModal.value,
          size: "md",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[22] || (_cache[22] = $event => showUrlImportModal.value = false)
        }, {
          footer: _withCtx(() => [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[21] || (_cache[21] = $event => showUrlImportModal.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            disabled: urlImporting.value,
            onClick: submitUrlImport
          }, _toDisplayString(urlImporting.value ? '提交中…' : '导入'), 9, _hoisted_95)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_90, [_cache[56] || (_cache[56] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "导入网页", -1)), _createElementVNode("p", _hoisted_91, "抓取网页正文并切块向量化到空间「" + _toDisplayString(current.value?.name) + "」（仅 http/https；同空间重复导入会被拒绝）", 1), _createElementVNode("div", _hoisted_92, [_createElementVNode("div", _hoisted_93, [_cache[54] || (_cache[54] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, [_createTextVNode("网页链接 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => urlImportForm.url = $event),
            class: "form-input w-full",
            placeholder: "https://example.com/policy/...",
            onKeyup: _withKeys(submitUrlImport, ["enter"])
          }, null, 544), [[_vModelText, urlImportForm.url]])]), _createElementVNode("div", _hoisted_94, [_cache[55] || (_cache[55] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "标题（可选）", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => urlImportForm.title = $event),
            class: "form-input w-full",
            placeholder: "缺省取网页标题",
            onKeyup: _withKeys(submitUrlImport, ["enter"])
          }, null, 544), [[_vModelText, urlImportForm.title]])])])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showSummaryModal.value,
          size: "2xl",
          "z-index": 70,
          onClose: _cache[23] || (_cache[23] = $event => showSummaryModal.value = false)
        }, {
          header: _withCtx(() => [_createTextVNode("AI 摘要" + _toDisplayString(summaryFileName.value ? '：' + summaryFileName.value : ''), 1)]),
          default: _withCtx(() => [summaryLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_96, " 摘要生成中（LLM 约需 10-30 秒）… ")) : summaryError.value ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(summaryError.value), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_98, [summaryTruncated.value ? (_openBlock(), _createElementBlock("p", _hoisted_99, "文档较长，摘要基于前段内容。")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryWarnings.value, w => {
            return _openBlock(), _createElementBlock("p", {
              key: w,
              class: "text-xs text-amber-600"
            }, _toDisplayString(w), 1);
          }), 128)), _withDirectives(_createElementVNode("div", _hoisted_100, null, 512), [[_directive_safe_html, summaryHtml.value]])]))]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showPreviewModal.value,
          size: "5xl",
          "panel-class": "h-[90vh] ring-1 ring-black/5",
          "z-index": 70,
          scrollable: false,
          onClose: closePreviewModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_101, [_cache[59] || (_cache[59] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_102, [_cache[57] || (_cache[57] = _createElementVNode("div", {
            class: "relative flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          })])], -1)), _createElementVNode("h3", _hoisted_103, _toDisplayString(previewFileName.value), 1)]), _createElementVNode("button", {
            class: "relative cursor-pointer rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white",
            onClick: closePreviewModal
          }, [...(_cache[58] || (_cache[58] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_104, [previewUrl.value ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            src: previewUrl.value,
            class: "h-full w-full border-0",
            frameborder: "0"
          }, null, 8, _hoisted_105)) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};